import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const Spinner: React.FC = () => {
    return (
        <div>
            <div className="popup-overlay" style={{ zIndex: 9999 }}></div>
            <div className='spinner'
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    border: 'none'
                }}
            >
                <CircularProgress
                    style={{
                        zIndex: 9999,
                    }}
                />
            </div>
        </div>
    );
};

export default Spinner;
